export enum ShareMode {
  None = 'none',
  OpenAR = 'open-AR',
  ShareAR = 'share-AR',
  Share3D = 'share-3D',
}
